import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from '../environments/environment';

interface ServerResponse<T> {
  content: T[];
  page: {
    size: number;
    number: number;
    totalElements: number;
    totalPages: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private http: HttpClient) {}

  getPaginatedData<T>(endpoint: string, page: number = 1, size: number = 10, query: string = ''): Observable<ServerResponse<T>> {
    const params = new HttpParams()
        .set('pageNumber', (page - 1).toString())
        .set('pageSize', size.toString())
        .set('query', query);

    return this.http.get<ServerResponse<T>>(`${environment.apiUrl}/${endpoint}`, { params });
  }

  getChronology(page: number = 1, size: number = 10, query: string = '') {
    return this.getPaginatedData<any>('public/chronology', page, size, query);
  }

  getArticles(page: number = 1, size: number = 10, query: string = '') {
    return this.getPaginatedData<any>('public/newspaper', page, size, query);
  }

  getHeroes(page: number = 1, size: number = 10, query: string = '') {
    return this.getPaginatedData<any>('public/hero', page, size, query); // Исправлен endpoint для героев
  }

  getFacts(page: number = 1, size: number = 10, query: string = '') {
    return this.getPaginatedData<any>('public/fact', page, size, query);
  }

  getItem<T>(endpoint: string, id: number | string): Observable<T> {
    return this.http.get<T>(`${environment.apiUrl}/public/${endpoint}/${id}`);
  }

  createItem<T>(endpoint: string, data: T): Observable<T> {
    return this.http.post<T>(`${environment.apiUrl}/${endpoint}`, data);
  }

  updateItem<T>(endpoint: string, id: number, data: T): Observable<T> {
    return this.http.post<T>(`${environment.apiUrl}/${endpoint}`, data);
  }

  deleteItem(endpoint: string, id: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/${endpoint}/${id}`);
  }

  uploadFile(endpoint: string, id: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${environment.apiUrl}/${endpoint}/file/${id}`, formData);
  }

  deleteFileChronology(id: number, index: number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/chronology/file/${id}/${index}`);
  }

  createWithFile(endpoint: string, data: any, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('data', JSON.stringify(data));
    formData.append('file', file);
    return this.http.post(`${environment.apiUrl}/${endpoint}/with-file`, formData);
  }

  moveUp(endpoint: string, id: number): Observable<boolean> {
    return this.http.put<boolean>(`${environment.apiUrl}/${endpoint}/move-up/${id}`, {});
  }

  moveDown(endpoint: string, id: number): Observable<boolean> {
    return this.http.put<boolean>(`${environment.apiUrl}/${endpoint}/move-down/${id}`, {});
  }

  createArticle(data: any, file?: File) {
    return file ?
        this.createWithFile('newspaper', data, file) :
        this.createItem('newspaper', data);
  }

  createHero(data: any, file?: File) {
    return file ?
        this.createWithFile('hero', data, file) :
        this.createItem('hero', data);
  }

  createFact(data: any, file?: File) {
    return file ?
        this.createWithFile('fact', data, file) :
        this.createItem('fact', data);
  }

  createChronology(data: any, file?: File) {
    return file ?
        this.createWithFile('chronology', data, file) :
        this.createItem('chronology', data);
  }

  submit(name: string, email: string, text: string, file: File) {
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post(`${environment.apiUrl}/public/appeal`,
        formData,
        {
          params: {
            name: name,
            email: email,
            text: text,
          }
        }
    );

  }

}